import { createAction, props } from '@ngrx/store';
import {
  CheckoutEventSuccess,
  CheckoutInitialisation,
  PaymentFrequency,
  QuoteResponse,
  RegistrationRequest,
  RegistrationResponse,
  RegistrationSystemCode,
  RegistriaUsersResponse,
  SerializationCodeResponse,
} from '@us-registration/util-models';

export const registerApplianceRequest = createAction(
  '[Registration] Register Appliance: Request',
  props<{ registrationRequest: RegistrationRequest }>()
);

export const registerAppliance = createAction(
  '[Registration] Register Appliance',
  props<{ registrationRequest: RegistrationRequest }>()
);

export const registerApplianceSuccess = createAction(
  '[Registration] Register Appliance: Success',
  props<{
    registrationResponse: RegistrationResponse;
  }>()
);

export const registerApplianceFailure = createAction(
  '[Registration] Register Appliance: Failure',
  props<{
    error: Error;
  }>()
);

export const getQuoteRequest = createAction(
  '[Registration] Get Quote: Request',
  props<{ registrationRequest: RegistrationRequest }>()
);

export const getQuote = createAction(
  '[Registration] Get Quote',
  props<{ registrationRequest: RegistrationRequest }>()
);

export const getQuoteSuccess = createAction(
  '[Registration] Get Quote: Success',
  props<{
    quoteResponse: QuoteResponse;
  }>()
);

export const getQuoteFailure = createAction(
  '[Registration] Get Quote: Failure',
  props<{
    statusCode: number;
  }>()
);

export const getQuoteNoContent = createAction(
  '[Registration] Get Quote: No Content',
  props<{
    statusCode: number;
  }>()
);

export const addSerializationCodeResponse = createAction(
  '[Registration] Add Serialization Code Response',
  props<{ serializationCodeResponse: SerializationCodeResponse }>()
);

export const addRegistrationSystemCode = createAction(
  '[Registration] Add Registration System Code',
  props<{ registrationSystemCode: RegistrationSystemCode }>()
);

export const addRegistriaUserResponse = createAction(
  '[Registration] Add Registria Response',
  props<{ registriaUserResponse: RegistriaUsersResponse }>()
);

export const addUserToken = createAction(
  '[Registration] Add User Token',
  props<{ userToken: string }>()
);
export const addCheckoutInitialisation = createAction(
  '[Registration] Add Checkout Initialisation',
  props<{ checkoutInitialisation: CheckoutInitialisation }>()
);

export const checkoutSuccess = createAction(
  '[Registration] Checkout Success',
  props<{ checkoutSuccess: CheckoutEventSuccess }>()
);

export const addPaymentFrequency = createAction(
  '[Registration] Add Payment Frequency',
  props<{ paymentFrequency: PaymentFrequency }>()
);
